import authClientService from "utils/graphql/authClient";
import { GET_EMPLOYEE_DEPARTMENTS, GET_EMPLOYEE_DESIGNATIONS, GET_PROJECTS_LIST, GET_TEACHERS, GET_VENDOR_ACCOUNTS, GET_VENDOR_USERS, GET_VENDORS } from "utils/graphql/services/live-classes/queries";
import * as Yup from "yup";

export type Observer = {
    vendorId: string;
    vendorAccountId: string;
    departmentId: string;
    designationId: string;
    teacherId: string;

};
//  co-host teacher, cohost vendoruser
export const ObserverInitialValues: Observer = {
    vendorId: "",
    vendorAccountId: "",
    departmentId: "",
    designationId: "",
    teacherId: "",

};

export const ObserverMandatoryFields = [];

export const ObserverValidationSchema = Yup.object().shape({

});

export const ObserverProperties = ()=>[

    {
        id: "vendorId",
        type: "single-select-search",
        label: "Vendor *",
        keyValue: { label: "name", value: "id" },
        query: GET_VENDORS,
        gqlKey: "getVendors",
        dataKey: "vendors",
        searchFieldKey: "searchName",
        breakpoints: { xs: 12, sm: 6, md: 4, lg: 3 },
        required: true,
    },
    {
        id: "vendorAccountId",
        type: "single-select-search",
        label: "Vendor Account *",
        query: GET_VENDOR_ACCOUNTS,
        gqlKey: "getVendorAccounts",
        dataKey: "vendorAccounts",
        keyValue: { label: "associatedDomainName", value: "id" },
        searchFieldKey: "associatedDomainName",
        dependentOn: "vendorId", // 🔥 ONLY THIS IS REQUIRED
        strictDependency: true,
        breakpoints: { xs: 12, sm: 6, md: 4, lg: 3 },
        required: true,
    },
    {
        id: "departmentId",
        type: "single-select-search",
        label: "Department *",
        keyValue: { label: "name", value: "id" },
        query: GET_EMPLOYEE_DEPARTMENTS,
        client: authClientService,
        gqlKey: "getEmployeeDepartments",
        dataKey: "employeeDepartments",
        searchFieldKey: "name",
        breakpoints: { xs: 12, sm: 6, md: 4, lg: 3 },
        required: true,
    },
    {
        id: "designationId",
        type: "single-select-search",
        label: "Designation *",
        keyValue: { label: "name", value: "id" },
        query: GET_EMPLOYEE_DESIGNATIONS,
        client: authClientService,
        gqlKey: "getEmployeeDesignations",
        dataKey: "employeeDesignations",
        searchFieldKey: "name",
        breakpoints: { xs: 12, sm: 6, md: 4, lg: 3 },
        required: true,
    },
    {
        id: "teacherId",
        type: "single-select-search",
        label: "Observer *",
        keyValue: {
            label: "employeeDropdownLabel",
            value: "employeeDropdownValue"
        },
        query: GET_TEACHERS,
        client: authClientService,
        gqlKey: "getTeachers",
        dataKey: "teachers",
        dependentOn: ["departmentId", "designationId"],
        searchFieldKey: "searchName",
        strictDependency: false,
        formatDependentPayload: ([departmentId, designationId]: any) => {
            return {
                ...(departmentId && { employeeDepartmentId: Number(departmentId) }),
                ...(designationId && { employeeDesignationId: Number(designationId) })
            };
        },
        formatData: (teachers: any[]) => {
            if (!teachers) return [];
            return teachers.map((teacher: any) => ({
                ...teacher,
                employeeDropdownLabel: `${teacher?.employee?.employeeId || ""} ${teacher?.employee?.firstName || ""} ${teacher?.employee?.lastName || ""}`.trim(),
                employeeDropdownValue: teacher?.id
            }));
        },
        breakpoints: { xs: 12, sm: 6, md: 4, lg: 3 },
        required: true,
    }

];

export function hasAtLeastOneValue(obj, keys) {
    return keys.some((key) => {
        const value = obj[key];
        return (
            value !== "" &&
            value !== null &&
            value !== undefined &&
            !(Array.isArray(value) && value.length === 0) &&
            !(Array.isArray(value) && value.every(v => v === null))
        );
    });
}
